<template>
  <span
    aria-hidden="true"
    class="flex shrink-0 items-center justify-center rounded bg-surface-muted p-1 text-text-secondary">
    <IconLucideCode2 class="h-3 w-3" />
  </span>
</template>

<script lang="ts">
/**
 * Fixed visual mark for developer-only UI (elements gated by `isDeveloper` /
 * `showDevActions`). Intentionally has no props — the mark must look identical
 * everywhere. Always placed left of the title/label it marks, as the first
 * child of a `flex items-center gap-2` row. See
 * `.claude/instructions/ui-display-conventions.md` (workspace root).
 */
export default {
  name: 'DevBadge',
}
</script>
